import { adapter, initialState } from './discount-code.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  ActivateDiscountCodeComplete,
  AddDiscountCodeComplete,
  DeactivateDiscountCodeComplete,
  DeleteDiscountCodeComplete,
  GetDiscountCodeComplete,
  LoadDiscountCodesComplete,
  UpdateDiscountCodeComplete,
} from './discount-code.actions'
import { upsertMany } from '@tokeet-frontend/utility'

const reducer = createReducer(
  initialState,
  on(LoadDiscountCodesComplete, (state, { items }) => upsertMany(adapter, items, { ...state, isLoaded: true })),
  on(AddDiscountCodeComplete, (state, { item }) => adapter.addOne(item, state)),
  on(GetDiscountCodeComplete, (state, { item }) => adapter.setOne(item, state)),
  on(UpdateDiscountCodeComplete, (state, { update }) => adapter.updateOne(update, state)),
  on(ActivateDiscountCodeComplete, (state, { id }) => adapter.updateOne({ id, changes: { status: 1 } }, state)),
  on(DeactivateDiscountCodeComplete, (state, { id }) => adapter.updateOne({ id, changes: { status: 0 } }, state)),
  on(DeleteDiscountCodeComplete, (state, { id }) => adapter.removeOne(id, state))
)

// AOT-friendly exported reducer function for StoreModule.forFeature
export function discountCodeReducer(state: typeof initialState | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
